import { hasOrderProductPendency } from '../orderProductsPendency.utils';
import OrderProductsSorterBuilder, {
  OrderProductsSorter,
  OrderProductsSorterSortParams,
} from './OrderProductsSorterBuilder';

class OrderProductsSorterPendency extends OrderProductsSorterBuilder {
  public sort<T extends OrderProductsSorter>({
    orderProducts,
    pendingOrderProductKeys,
  }: OrderProductsSorterSortParams<T>): T[] {
    const withErrors: T[] = [];
    const withoutErrors: T[] = [];

    for (const op of orderProducts) {
      if (hasOrderProductPendency(op, pendingOrderProductKeys)) {
        withErrors.push(op);
      } else {
        withoutErrors.push(op);
      }
    }

    return [...withErrors, ...withoutErrors];
  }
}

export default OrderProductsSorterPendency;
